import {Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import ServicesIcon from '@icons/ServicesIcon';

export default function ServicesButton(props: any) {
	const {t} = useTranslation();
	
	return (
		<Link to="/services" {...props}>
			<Stack direction="column" alignItems="center" spacing={0.5}>
				<ServicesIcon active={props['aria-selected']}/>
				<Typography fontSize={12}>{t('services')}</Typography>
			</Stack>
		</Link>
	);
}
